<template>
  <div class="payment-detail-page new-payment-design">
    <!-- <Header /> -->
    <div>
      <h2>Choose your preferred mode of payment</h2>
      <v-card>
        <v-list-item>
          <v-list-item-content>
            <p>Please select your convenient mode of payment</p>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-card @click="choosePaymentMethod('cashfree')">
              <v-img
                max-height="120"
                max-width="120"
                :src="cashfree_pic"
                :lazy-src="cashfree_pic"
              ></v-img>
              <span>Internet banking/UPI's/Wallets/Cards</span>
              <v-img
                max-height="20"
                max-width="20"
                src="../../assets/images/right-arrow.png"
              ></v-img>
            </v-card>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-card @click="choosePaymentMethod('razorpay')">
              <v-img
                max-height="120"
                max-width="120"
                :src="razorpay_pic"
                :lazy-src="razorpay_pic"
              ></v-img>
              <span>UPI's/Netbanking/Cards</span>
              <v-img
                max-height="20"
                max-width="20"
                src="../../assets/images/right-arrow.png"
              ></v-img>
            </v-card>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <p>
              Receipt will be generated and will be sent to the registered email
              provided.
            </p>
          </v-list-item-content>
        </v-list-item>

        <v-label>Promo Code (Optional)</v-label>
        <v-list-item>
          <v-text-field
            name="promo_code"
            ref="promo_code"
            v-model="promo_code"
            placeholder="Enter Promo Code"
            class="promocode_cls"
            :readonly="readonly"
          ></v-text-field>
        </v-list-item>

         
        <v-list-item>
          <p style="color: red" v-if="!is_promocode_valid">
            {{ promocode_validation_message }}
          </p>
          <p style="color: green" v-else>{{ promocode_validation_message }}</p>
        </v-list-item>
         
        <v-list-item v-if="this.promo_code != ''">
          <b
            >Note: You are eligable for ({{ deduction_percentage }}%) discount
            on your subscription fee.</b
          >
        </v-list-item>
        <v-list-item v-if="showReedemedPointBox">
        </v-list-item>  
        <v-list-item v-if="showReedemedPointBox">
          <v-label style="width:849px !important;"><b>You have {{this.user_reward_points}} reward points. Do you want to redeem (Optional)?</b></v-label>

          <v-list-item>
            <v-select
              :v-model = "is_redeemed_point"
              :items   = "is_redeemed_point_items"
              item-value="id"
              item-text="name"
              id="is_redeemed_point"
              placeholder = 'Do you want to redeem?'
              
              return-object
              outlined
              color="blue"      
            ></v-select> 
          </v-list-item>
        
        </v-list-item> 
        <v-list-item v-else>
          <b>Enter Vaild promocode then choose payment options.</b>
        </v-list-item>
         <v-list-item >
          <v-row class="buttonbox" style="border: none !important; background-color: #C7ECF8 !important;">
            <v-btn class="blue-border-btn" style="background-color: #D9E6EA !important;" @click="backButton"> Back </v-btn>
          </v-row>
        </v-list-item>  
      </v-card>
      <div class="text-center">
        <v-dialog v-model="after_payment_dialog" width="500">
          <v-card
            class="secure-modal plan-modalbox subsription-successful-modal"
          >
            <v-card-text>
              <div class="plan-detailbox">
                <div class="box-head-content">
                  <h2>Subscription Successful</h2>
                  <v-img
                    max-height="50"
                    max-width="50"
                    :src="plan_image"
                  ></v-img>
                  <h2>Hi {{ full_name }}</h2>
                  <h1>Thank you for subscribing to Nimeya.ai.</h1>
                </div>
                <div class="plan-price_box">
                  <h2>{{ userDetails["name"] }} Plan</h2>
                  <h2
                    v-if="
                      userDetails['amount'] > userDetails['discountedPrice']
                    "
                  >
                    <span>&#8377;</span
                    ><span class="text-decoration-line-through">{{
                      userDetails["amount"]
                    }}</span>
                    {{ userDetails["discountedPrice"] }} /<span
                      class="light-weight"
                      >yr</span
                    >
                  </h2>
                  <h2 v-else>
                    <span>&#8377;</span> {{ userDetails["amount"] }}/<span
                      class="light-weight"
                      >yr</span
                    >
                  </h2>
                  <span>Date of Expiry : {{ userDetails.expiry_by }}</span>
                </div>
                <ul>
                  <h2>Plan Details</h2>
                  <li
                    v-for="json_decoded_notes in userDetails[
                      'json_decoded_notes'
                    ]"
                  >
                    {{ json_decoded_notes["note"] }}
                  </li>
                  <span
                    style="
                      margin-top: 25px;
                      font-weight: bold;
                      color: rgb(0, 0, 0);
                      display: block;
                    "
                    >*Condition Apply</span
                  >
                </ul>
              </div>
              <v-card-actions>
                <v-btn class="blue-btn btn" @click="isProceedalert">
                  PROCEED
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import Header from "../common/Header.vue";
import {
  CREATE_PAYMENT_LINK,
  GET_PAYMENT_INFO,
  UPDATE_PROFILE_DETAIL,
} from "../../store/actions.type";
import JwtService from ".././common/jwt.service";
import { isEmpty } from "lodash";
import ApiService from "../../api/api.service";
import axios from "axios";
export default {
  components: { Header },
  data: () => ({
    after_payment_dialog: false,
    userDetails: [],
    icon: "sliver-icon.png",
    plan_image: process.env.VUE_APP_ROOT_ICONS_URL + "success-tick.svg",
    w: null,
    cashfree_pic: process.env.VUE_APP_ROOT_ICONS_URL + "cashfree.png",
    razorpay_pic: process.env.VUE_APP_ROOT_ICONS_URL + "razorpay.png",
    name: "",
    email: "",
    mobile_no: "",
    payment_link_info: "",
    dialog: false,
    is_payment_confirmation: false,
    plan_id: null,
    full_name: null,
    myInterval:'',
    promo_code: "",
    deduction_percentage: "",
    readonly: false,
    promo_code: "",
    is_promocode_valid: false,
    promocode_validation_message: "",
   
    is_redeemed_point_items:[{'id':'no', 'name':'No'}, {'id':'yes', 'name':'Yes'}],
    showReedemedPointBox : false,
    is_redeemed_point:'yes',
    user_reward_points:''
  }),
  created() {

    if(localStorage.getItem('showReedemedPointBox') == '1'){
      this.showReedemedPointBox = true
    }
    Auth.currentAuthenticatedUser({
      bypassCache: true,
    })
      .then((user) => {
        this.name = user.attributes["custom:name"];
        this.email = user.attributes["email"];
        this.mobile_no = user.attributes["custom:phonenumber"];
      })
      .catch((err) => {
        this.$router.push({ name: "Login" }).catch(() => {});
      });

    let cognito_idp = atob(localStorage.getItem("cognito_idp"));

    let formdata = new FormData();
    formdata.append("aws_cognito_id", cognito_idp);
    axios
      .post(process.env.VUE_APP_ROOT_API + "get-user-promocode", formdata)
      .then((response) => {
        console.log(response.data)
          this.user_reward_points = response.data.reward_point
        this.promo_code = response.data.data;
        if (this.promo_code) {
          this.readonly = true;
        }
        this.deduction_percentage = response.data.deduction_percentage;
      })
      .catch(() => {});
  },

  watch: {
    promo_code(val) {
      this.promo_code = val.toUpperCase();
      if (val.length > 6) {
        if (val.keyCode >= 48 && val.keyCode <= 90) {
          val.preventDefault();
          return;
        }
      }
      let formdata = new FormData();
      formdata.append("promo_code", val);
      formdata.append("type", "second_time");
      axios
        .post(process.env.VUE_APP_ROOT_API + "validate-promocode", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {

          if (response.data.status == "error") {
            this.is_promocode_valid = false;
            if (val == "") {
              this.promocode_validation_message = "";
            } else {
              this.promocode_validation_message = "Invalid Promocode!";
            }
          } else {
            this.is_promocode_valid = true;
            this.promocode_validation_message = "Valid Promocode";
          }
        })
        .catch((e) => {});
    },
  },
  methods: {
    backButton(){
      clearInterval(this.myInterval);
      this.$router.push({ name: "pricingPlan"}).catch(()=>{});
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    isProceedalert() {
      this.$router.push({ name: "Investometer" }).catch(() => {});
    },
    choosePaymentMethod(payment_type) {
     // this.$loading(true);
      if (this.promo_code == "NIM100") {
        this.promo_code = "";
      }
     
      this.$store
        .dispatch(CREATE_PAYMENT_LINK, {
          data: {
            awsCognitoId: atob(localStorage.getItem("cognito_idp")),
            paymentType: payment_type,
            planId: this.$route.params.plan_id,
            userMobile: this.mobile_no.replace("+", ""),
            userName: this.name,
            userEmail: this.email,
            promo_code: this.promo_code,
            is_redeemed_point:this.is_redeemed_point
          },
          api: "create-payment-link",
        })
        .then(() => {
          this.$loading(false);
          this.payment_link_info = this.$store.getters.getPaymentLinkInfo.data;
          let link_url =
            payment_type == "cashfree"
              ? this.payment_link_info.link_url
              : this.payment_link_info.short_url;
          this.openWindow = window.open(link_url, "", "width=900,height=500");
          this.is_payment_confirmation = true;
          let self = this;
          this.myInterval = setInterval(function () {self.confirmPayment("now")}, 50000);
        })
        .catch((err) => {
          this.$loading(false);
        });
    },

    confirmPayment(time) {
      this.$store
        .dispatch(GET_PAYMENT_INFO, {
          data: {
            awsCognitoId: atob(localStorage.getItem("cognito_idp")),
            userMobile: this.mobile_no.replace("+", ""),
            user_name: this.name,
            userEmail: this.email,
          },
          api: "get-payment-info",
        })
        .then(() => {
          this.payment_link_info = this.$store.getters.getPaymentLinkInfo;
          
          if (this.payment_link_info.payment_status == "PAID") {
            clearInterval(this.myInterval);
            this.openWindow.close();
            let updatedDetail = [
              { key: "is_plan_active", value: 1 },
              {
                key: "subscription_plans",
                value: this.$store.getters.getPaymentLinkInfo.data.plan_id,
              },
              { key: "show_add_family_member_button", value: 1 },
            ];
            this.$store.dispatch(UPDATE_PROFILE_DETAIL, updatedDetail);
            let cognito_idp = atob(localStorage.getItem("cognito_idp"));
            ApiService.setHeader();
            ApiService.post("get-user-plan-detail", {
              aws_cognito_id: cognito_idp,
            }).then((response) => {
              this.userDetails = response.data.data;
            });
            if (time == "now") {
              this.after_payment_dialog = true;
              this.full_name = this.capitalize(this.name);
            } else {
              this.logout();
            }
          }
        })
        .catch(() => {
          this.$loading(false);
        });
    },

    logout() {
      this.$store.commit("setPaymentLinkInfo", {});
      localStorage.clear();
      this.$router.push({ name: "Login" }).catch(() => {});
    },
  },
};
</script>
<style scoped>
.promocode_cls {
  background-color: #cddce1 !important;
  padding: 20px 15px !important;
  max-height: unset;
}
</style>